export default __webpack_public_path__ + "static/Mussee-03bdf5e0d805c838879c568c6c878be0.jpg";